import { Brand, createBranded } from '@deltasierra/type-utilities';

export type BuilderTemplateCategoryId = Brand<number, 'BuilderTemplateCategoryId'>;
export const BuilderTemplateCategoryId = createBranded<BuilderTemplateCategoryId>();
